import React, { FC } from 'react'
import { ProductWrapper } from '@dg-shared/index'
import { useTranslate } from '../../hooks/shared'
import { Tab, Tabs } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'
import { PartnerName, ProductName } from '../../types/interface/quote.interface'

type ProductSelectPropsType = {
  handleProductChange: (product: ProductName) => void
  selectedProduct: ProductName
  availableProducts?: ProductName[]
}

export const useStyles = makeStyles()((theme: Theme) => ({
  tabsWrapper: {
    '& .MuiButtonBase-root': {
      minWidth: 120,
    },
    marginBottom: theme.spacing(3),
  },
}))

const ProductSelect: FC<ProductSelectPropsType> = ({
  handleProductChange,
  selectedProduct,
  availableProducts,
}) => {
  const { t } = useTranslate()
  const { classes } = useStyles()
  const productNames: ProductName[] = [ProductName.VEHICLE, ProductName.TRAVEL, ProductName.CONTENT]

  // When availableProducts is provided (invoices page), intersect with the canonical order.
  // When not provided (policies page), use the full partner-based list via ProductWrapper.
  const filteredProductNames = availableProducts
    ? productNames.filter((p) => availableProducts.includes(p))
    : productNames

  const handleTabChange = (event: React.SyntheticEvent, productNameIndex: number) =>
    handleProductChange(filteredProductNames[productNameIndex])

  const tabValue = filteredProductNames.indexOf(selectedProduct)

  // When availableProducts is provided, render only the filtered tabs (no ProductWrapper gating).
  if (availableProducts) {
    if (filteredProductNames.length <= 1) return null

    const getTabLabel = (p: ProductName): string => {
      if (p === ProductName.TRAVEL) return t('productFilterTravel') as string
      if (p === ProductName.CONTENT) return t('productFilterContent') as string
      return t('productFilterCar') as string
    }

    return (
      <Tabs
        textColor='primary'
        indicatorColor='primary'
        value={tabValue < 0 ? 0 : tabValue}
        onChange={handleTabChange}
        aria-label='title'
        className={classes.tabsWrapper}
      >
        {filteredProductNames.map((p) => (
          <Tab key={p} label={getTabLabel(p)} />
        ))}
      </Tabs>
    )
  }

  return (
    <>
      <ProductWrapper products={[ProductName.VEHICLE]} partners={[PartnerName.coverme]}>
        <Tabs
          textColor='primary'
          indicatorColor='primary'
          value={tabValue}
          onChange={handleTabChange}
          aria-label='title'
          className={classes.tabsWrapper}
        >
          <Tab label={t(`productFilterCar`)} />
        </Tabs>
      </ProductWrapper>
      <ProductWrapper
        products={[ProductName.CONTENT, ProductName.TRAVEL, ProductName.VEHICLE]}
        partners={[PartnerName.instabank, PartnerName.nord]}
      >
        <Tabs
          textColor='primary'
          indicatorColor='primary'
          value={tabValue}
          onChange={handleTabChange}
          aria-label='title'
          className={classes.tabsWrapper}
        >
          <Tab label={t(`productFilterCar`)} />
          <Tab label={t(`productFilterTravel`)} />
          <Tab label={t(`productFilterContent`)} />
        </Tabs>
      </ProductWrapper>
    </>
  )
}

export default ProductSelect
